import styled from 'styled-components';

export const Input = styled.input`
  width: 100%;
  height: 4rem;
  overflow: hidden;
  border-radius: 0.4rem;
  border: 1px solid hsl(207, 22%, 90%);
  background-color: hsl(0, 100%, 100%);
  padding: 1rem;
  margin: 1rem 0;
`;



// WEBPACK FOOTER //
// ./src/pages/Delivery/elements.js